// Library Imports
import { useEffect, useRef } from 'react';
import { FiltersIcon } from '../../../assets/icons';

interface PopOverProps {
  menuHeading?: JSX.Element | string | undefined;
  children?: React.ReactNode;
  dropdownOpen?: boolean;
  setDropdownOpen?: (arg: boolean) => void;
  active?: boolean;
  className?: string;
}

const Popover = ({
  dropdownOpen,
  setDropdownOpen,
  menuHeading,
  children,
  active,
  className
}: PopOverProps) => {
  const trigger = useRef<any>(null);
  const dropdown = useRef<any>(null);

  // Close on click outside
  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (!dropdown?.current) return;
      if (!dropdownOpen || dropdown?.current.contains(target) || trigger?.current.contains(target))
        return;
      setDropdownOpen?.(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // Close if the scroll outside & not focus
  useEffect(() => {
    const handleScroll = (event: any) => {
      if (event?.deltaX !== 0 || event?.deltaY !== 0) {
        !dropdown?.current?.contains(event?.target) && setDropdownOpen?.(false);
      }
    };
    document.addEventListener('wheel', handleScroll);

    return () => document.removeEventListener('keydown', handleScroll);
  });

  return (
    <div className='relative'>
      <div
        ref={trigger}
        onClick={() => setDropdownOpen?.(!dropdownOpen)}
        className='flex items-center gap-2'
      >
        {menuHeading === 'Filters' ? (
          <div
            className={`flex border justify-center items-center gap-2 text-gray-600 cursor-pointer rounded-lg py-2 px-3 focus-within:border-gray-300 focus-within:border-[1.5px] bg-bgGray h-[40px] ${
              active ? 'border-[#3362DA]' : ''
            }`}
          >
            <FiltersIcon
              className={`'w-5 h-5 mt-[1px]  ${active ? '!text-[#3362DA]' : '!text-gray-400/80'} `}
            />
            <p className={` ${active ? '!text-[#3362DA]' : ''} `}>Filters</p>
          </div>
        ) : menuHeading ? (
          menuHeading
        ) : (
          <p> Menu Heading</p>
        )}
      </div>

      {/* Popover Start  */}
      <div
        // ref={dropdown}
        className={`z-[50] absolute top-8 right-1 my-4 flex w-[200px] flex-col rounded-md border border-stroke bg-white shadow-lg  ${
          dropdownOpen === true ? 'block' : 'hidden'
        } ${className}`}
      >
        <div className='flex flex-col border-stroke my-1'>
          {children ? (
            children
          ) : (
            <>
              <p className='hover:bg-slate-100 px-2 py-3'>Menu Content</p>
            </>
          )}
        </div>
      </div>
      {/* Popover End  */}
    </div>
  );
};

export default Popover;
